import { render } from "./d-switch-table.vue?vue&type=template&id=60d7b562&scoped=true&ts=true"
import script from "./d-switch-table.vue?vue&type=script&lang=ts"
export * from "./d-switch-table.vue?vue&type=script&lang=ts"

import "./d-switch-table.vue?vue&type=style&index=0&id=60d7b562&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d7b562"]])

export default __exports__